import React, { useRef, useState, useEffect } from "react";
import Dynamic_PR_table from "../../../../components/Dynamic_PR_table";
import { API_URL } from "../../../../constants";
import { GetServiceCaller } from "../../../../services/serviceCaller";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../../constants/layout/store/filterSlice";
import moment from "moment";

const OfferLetterListing = () => {
  const modalRef = useRef(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [offerLetterList, setOfferLetterList] = useState([]); 
  const [statusList, setStatusList] = useState([]);
  const [apiStatus, SetApiStatus] = useState("");
  const [filterFormData, setFilterData] = useState([]);
  const [respStatus, setRepStatus] = useState(0);
  const [OfferLetterModal, setOfferLetterModal] = useState(false);
  const [offerParameters, setOfferParameters] = useState({});
  const [offerLetterDetail, setOfferLetterDetail] = useState([]);
  const [view, setView] = useState("");

  const columns = {
    FullName: { text: "Name", visible: true },
    Email: { text: "Email", visible: true },
    MobileNo: { text: "Contact No.", visible: true, align: "center" },
    OfferLetterSenderName: { text: "Sender", visible: true },
    OfferLetterSendDate: { text: "Send Date", visible: true, align: "center" },
    OfferLetterStatus: { text: "Status", visible: true },
  };

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(updateNavbarHeading("Offer Letter Listing"));
  }, []);
  const formDatas = [
    { name: "From Date", type: "Date" },
    { name: "To Date", type: "Date" },
    { name: "Status", type: "Select", options: [...statusList] },
  ];
  const handleChange = (e, name) => {
    setFilterData((prevFormData) => {
      // Check if the label already exists
      const existingLabelIndex = prevFormData.findIndex(
        (item) => item.label === name
      );

      // If the label exists, update its value
      if (existingLabelIndex !== -1) {
        const updatedFormData = prevFormData.map((item, index) =>
          index === existingLabelIndex
            ? { ...item, value: e.value !== undefined ? e.value : e }
            : item
        );
        return updatedFormData;
      } else {
        return [
          ...prevFormData,
          {
            label: name,
            value: e.value !== undefined ? e.value : e,
          },
        ];
      }
    });
  };
  function formatIndianNumber(number) {
    if (number === null || number === undefined) return "";

    const numParts = number.toString().split(".");
    let integerPart = numParts[0];
    const decimalPart = numParts.length > 1 ? "." + numParts[1] : "";

    const lastThreeDigits = integerPart.slice(-3);
    const otherDigits = integerPart.slice(0, -3);

    if (otherDigits !== "") {
      integerPart =
        otherDigits.replace(/\B(?=(\d{2})+(?!\d))/g, ",") +
        "," +
        lastThreeDigits;
    }

    return integerPart + decimalPart;
  }

  useEffect(() => {
    fetchOfferLetterData();
    fetchOfferLetterStatusList();
  }, []);
  const fetchOfferLetterStatusList = async () => {
    SetApiStatus(undefined);
    try {
      const response = await GetServiceCaller(`${API_URL}offer-letter-status`);
      SetApiStatus(response?.status);
      if (response?.status === 200) {
        const data = response?.data?.data || [];
        // status list
        const statusList = response?.data?.data?.map((tech) => ({
          value: tech.value,
          label: tech.text,
        }));
        setStatusList(statusList);
        setRepStatus(response.status);
      }
    } catch (error) {
      console.error("Error fetching skills:", error);
    }
  };
  const fetchOfferLetterData = async () => {
    SetApiStatus(undefined);
    try {
      const response = await GetServiceCaller(
        `${API_URL}report/13?P_FromDate=&P_ToDate=&P_Status=`
      );
      SetApiStatus(response?.status);
      if (response?.status === 200) {
        const data = response?.data?.data?.reverse() || [];
        setOfferLetterList(data);
        setRepStatus(response.status);
      }
    } catch (error) {
      console.error("Error fetching skills:", error);
    }
  };

  const handleGetData = async () => {
    SetApiStatus(undefined);

    try {
      const response = await GetServiceCaller(
        `${API_URL}report/13?P_FromDate=${
          filterFormData.find((o) => o.label === "From Date")
            ? moment(
                filterFormData.find((o) => o.label === "From Date").value
              ).format("YYYY-MM-DD")
            : ""
        }&P_ToDate=${
          filterFormData.find((o) => o.label === "To Date")
            ? moment(
                filterFormData.find((o) => o.label === "To Date").value
              ).format("YYYY-MM-DD")
            : ""
        }&P_Status=${
          filterFormData.find((o) => o.label === "Status")
            ? filterFormData.find((o) => o.label === "Status").value
            : ""
        }`
      );
      SetApiStatus(response?.status);
      if (response?.status === 200) {
        const data = response?.data?.data?.reverse() || [];
        setOfferLetterList(data);
        setRepStatus(response.status);
      }
    } catch (error) {
      console.error("Error fetching skills:", error);
    }
  };

  const handleReset = () => {
    setOfferLetterList([]);
    setFilterData([]);
    fetchOfferLetterData();
  };
  const handleCloseModal = () => {
    setOfferLetterModal(false);
  };

  const handleOfferLetterStatus = async (OfferLetterID) => { 
    setOfferLetterModal(true);
    try {
      let encodedOfferLetterID = btoa(OfferLetterID);

      const response = await GetServiceCaller(
        `${API_URL}offer-letter-details/${encodedOfferLetterID}`
      );
      let html = response?.data?.header.replaceAll(
        '<img src="#emailDocSign#" style="width:100px;height: 50px;">',
        ""
      );
      html = html.replaceAll(
        '<img src="#emailDocSign#" style="width:100px;height: 50px;margin-left:80px;margin-bottom:-12px;">',
        ""
      );
      setView(html);
      setOfferLetterDetail(response.data.offerletter[0]);
      setOfferParameters(response.data.offerParameter);
    } catch (error) {
      console.error("Error fetching offer letter data:", error);
    }
  };
  const handleView = (id) => {    
    handleOfferLetterStatus(id.CandidateID);
    setOfferLetterModal(true);
  };
    useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        handleCloseModal();
      }
    };

    if (OfferLetterModal) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [OfferLetterModal]);
  return (
    <>
      <div className="container-fluid" id="skill_section">
        <div className="container-fluid" id="skill-table-area">
          <div className="row mt-2">
            <Dynamic_PR_table
              data={offerLetterList}
              columns={columns}
              itemsPerPage={8}
              searchTerm={searchTerm}
              setSearchTerm={setSearchTerm}
              handleReset={handleReset}
              showIcon1={true}
              isSorting={true}
              isFilterRequired={true}
              isActionRequired={true}
              isApiStatus={apiStatus}
              isRequiredStatus={true}
              formDatas={formDatas}
              handleChange={handleChange}
              handleGetData={handleGetData}
              filterFormData={filterFormData}
              handleIcon1={handleView}
              icons={{
                Icon1: <i className="bi bi-eye-fill"></i>,
                Icon1Text: "View Offer Letter",
              }}
            />
          </div>
        </div>
        {OfferLetterModal && (
          <div
            className="modal"
            tabIndex="-1"
            role="dialog"
            style={{ display: "block", backgroundColor: "rgba(0, 0, 0, 0.5)" }}
          >
            <div className="modal-dialog modal-lg" role="document"   ref={modalRef}  onClick={(e) => e.stopPropagation()}>
              <div className="modal-content">
                <div className="modal-header"     
                   style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    borderBottom: "1px solid #f0f0f0",
                    backgroundColor: "#f8f9fa",
                    borderRadius: "8px 8px 0 0",
                    padding: "12px 16px",
                  }}>
               <p
                    style={{
                      fontSize: "16px",
                      fontWeight: "600",
                      color: "#27568B",
                      margin: "0",
                    }}
                  >
                   Offer Letter
                  </p>
                  <button
                    onClick={handleCloseModal}
                    style={{
                      background: "none",
                      border: "none",
                      cursor: "pointer",
                      fontSize: "18px",
                      color: "#000",
                      padding: "4px",
                      borderRadius: "4px",
                      transition: "all 0.2s",
                      lineHeight: "1",
                    }}
                  >
                    <i className="bi bi-x-lg"></i>
                  </button>
                </div>
                <div className="modal-body">
                  <div className="row">
                    <div className="col-sm-12">
                      <div dangerouslySetInnerHTML={{ __html: view }}></div>
                    </div>
                  </div>
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={() => setOfferLetterModal(false)}
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default OfferLetterListing;
